import { z } from "zod";
import { Id } from "../base";
import { TimestampSchema } from "../epoch";
export const communityAdminOnboardingStepIds = [
    "create-campaign",
    "launch-campaign",
    "review-submissions",
];
export const CommunityAdminOnboardingStepIdSchema = z.enum(communityAdminOnboardingStepIds);
export const CommunityAdminOnboardingProgressSchema = z.object({
    id: Id,
    communityId: Id,
    userId: Id,
    completedSteps: z
        .object({
        "create-campaign": TimestampSchema.optional(),
        "launch-campaign": TimestampSchema.optional(),
        "review-submissions": TimestampSchema.optional(),
    })
        .partial()
        .default({}),
    updatedAt: TimestampSchema,
});
